import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';

import {P} from '@/typography';
import classNames from 'classnames';

const propTypes = {
  formId: PropTypes.string.isRequired,
  className: PropTypes.string,
  formLoadingErrorMessage: PropTypes.object
};

const hubspotScriptUrl = process.env.NEXT_PUBLIC_HUBSPOT_LOADING_SCRIPT;

const HubSpotForm = props => {
  const SCRIPT_STATUSES = {
    PRISTINE: 0,
    LOADED: 1,
    FAILED: 2
  };
  const {formId, className} = props;
  const {formLoadingErrorMessage} = props;
  const hubspotProps = {...props};
  delete hubspotProps.formLoadingErrorMessage;

  const [scriptStatus, setScriptStatus] = useState(SCRIPT_STATUSES.PRISTINE);

  const hubspotScriptLoaded = () => {
    if (typeof window !== 'undefined' && 'hbspt' in window) {
      window.hbspt.forms.create({
        ...hubspotProps,
        target: `#HubSpotForm${formId}`
      });

      setScriptStatus(SCRIPT_STATUSES.LOADED);
    }
  };

  const hubspotScriptErrored = () => {
    setScriptStatus(SCRIPT_STATUSES.FAILED);
  };

  if (scriptStatus === SCRIPT_STATUSES.FAILED) {
    return (
      <div id={`HubSpotForm${formId}`} className="form-loading-error">
        <P>
          {formLoadingErrorMessage ??
            'An error occurred while loading the form. Please try again later.'}
        </P>
      </div>
    );
  }

  return (
    <>
      <Script
        id="hubspot-script"
        src={hubspotScriptUrl}
        strategy="afterInteractive"
        onReady={hubspotScriptLoaded}
        onError={hubspotScriptErrored}
      />

      <div className={classNames(className, 'hs-form-loading')} id={`HubSpotForm${formId}`}>
        <p>Loading...</p>
      </div>
    </>
  );
};

HubSpotForm.propTypes = propTypes;

export default HubSpotForm;
